import React, { Fragment, useEffect } from "react";
import "./style.css";
import { Box } from "@mui/material";
import DesktopCart from "./DesktopCart";
import MobileCart from "./MobileCart";
import useSystemHook from "./../../hooks/SystemHook";

const Cart = ({
  loading,
  customerCategory,
  pricingData,
  vat,
  cartNettTotal,
  settlementAmount,
  vatAmount,
  total,
  createCheckout,
  goBack,
  clearCartMetadata,
  emptyCart,
  totalItems,
  updateItemQuantity,
  items,
  removeItem,
  setItems,
}) => {
  const scrollToTop = () => {
    window.scroll(0, 0);
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  const { isMobile, isTablet, isDesktop } = useSystemHook();

  return (
    <>
      {loading === false && (
        <Box sx={{ minHeight: !isMobile ? "60vh" : "" }}>
          {isMobile ? (
            <MobileCart
              loading={loading}
              customerCategory={customerCategory}
              pricingData={pricingData}
              vat={vat}
              cartNettTotal={cartNettTotal}
              settlementAmount={settlementAmount}
              vatAmount={vatAmount}
              total={total}
              createCheckout={createCheckout}
              goBack={goBack}
            />
          ) : (
            <DesktopCart
              loading={loading}
              customerCategory={customerCategory}
              pricingData={pricingData}
              vat={vat}
              cartNettTotal={cartNettTotal}
              settlementAmount={settlementAmount}
              vatAmount={vatAmount}
              total={total}
              createCheckout={createCheckout}
              goBack={goBack}
              items={items}
              setItems={setItems}
              removeItem={removeItem}
              emptyCart={emptyCart}
              clearCartMetadata={clearCartMetadata}
              updateItemQuantity={updateItemQuantity}
              totalItems={totalItems}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default Cart;
